import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createVNode as _createVNode, normalizeStyle as _normalizeStyle, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3fc58238"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "books__icons" }
const _hoisted_2 = { class: "books__link" }
const _hoisted_3 = { class: "books__progress progress" }
const _hoisted_4 = ["aria-valuenow"]
const _hoisted_5 = { class: "books__text-box" }
const _hoisted_6 = { class: "books__text" }
const _hoisted_7 = { class: "books__wrapper" }
const _hoisted_8 = { class: "books__category card__category" }
const _hoisted_9 = { class: "books__title card__title" }
const _hoisted_10 = { class: "books__author card__author" }

import { computed } from 'vue'

import DocListsMenu from '@/app/components/doc/DocListsMenu.vue'
import BookListenIcon from '@/app/components/book/card/BookListenIcon.vue'
import FreeBookIcon from '@/app/components/book/card/FreeBookIcon.vue'
import BookCardThumbnail from '@/app/components/book/card/BookCardThumbnail.vue'
import DocLibraryMenu from '@/app/components/doc/DocLibraryMenu.vue'
import CustomListDocMenu from '@/app/components/custom.lists/CustomListDocMenu.vue'

import { Book, CustomList } from '@/models/interfaces'
import { BooksView } from '@/models/doc.book'


export default /*#__PURE__*/_defineComponent({
  __name: 'BookCard',
  props: {
    doc: null,
    view: null,
    showFreeBooks: { type: Boolean, default: true },
    customList: null
  },
  setup(__props: any) {

const props = __props as { doc: Book, view: BooksView, showFreeBooks: boolean, customList?: CustomList };



const isCTA = computed(() => {
  return props.doc.title === 'CTA'
})

const showCustomListActions = computed(() => {
  return (
    props.view.showActionsButton && props.customList?.doc_type === 'custom_list'
  )
})

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (!_unref(isCTA))
    ? (_openBlock(), _createBlock(_component_router_link, {
        key: 0,
        to: __props.view.startLinkParams(__props.doc),
        class: _normalizeClass(["books__item", __props.doc.id])
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            (__props.doc.has_audio)
              ? (_openBlock(), _createBlock(BookListenIcon, { key: 0 }))
              : _createCommentVNode("", true),
            (__props.doc.is_free && __props.showFreeBooks)
              ? (_openBlock(), _createBlock(FreeBookIcon, { key: 1 }))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_2, [
            _createVNode(BookCardThumbnail, {
              class: "books__img-box",
              coverClass: "books__img",
              fallbackCoverClass: "books__img",
              doc: __props.doc,
              cacheBust: true
            }, null, 8, ["doc"]),
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("div", {
                "aria-valuenow": __props.doc.progress,
                "aria-valuemin": "0",
                "aria-valuemax": "100",
                style: _normalizeStyle({ width: __props.doc.progress + '%' }),
                class: "progress__now"
              }, null, 12, _hoisted_4)
            ]),
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("div", _hoisted_7, [
                  _createElementVNode("h5", _hoisted_8, _toDisplayString(__props.view.firstTag(__props.doc)), 1),
                  _createVNode(DocListsMenu, {
                    doc: __props.doc,
                    docsView: __props.view
                  }, null, 8, ["doc", "docsView"])
                ]),
                _createElementVNode("h3", _hoisted_9, _toDisplayString(__props.doc.title), 1),
                _createElementVNode("h4", _hoisted_10, "By " + _toDisplayString(__props.doc.author), 1)
              ]),
              (_unref(showCustomListActions))
                ? (_openBlock(), _createBlock(CustomListDocMenu, {
                    key: 0,
                    class: "books__actions books__actions--list-page",
                    doc: __props.doc,
                    docsView: __props.view,
                    list: __props.customList,
                    position: "right"
                  }, null, 8, ["doc", "docsView", "list"]))
                : (__props.view.showActionsButton)
                  ? (_openBlock(), _createBlock(DocLibraryMenu, {
                      key: 1,
                      class: "books__actions books__actions--library",
                      doc: __props.doc,
                      docsView: __props.view,
                      position: "right"
                    }, null, 8, ["doc", "docsView"]))
                  : _createCommentVNode("", true)
            ])
          ])
        ]),
        _: 1
      }, 8, ["to", "class"]))
    : _createCommentVNode("", true)
}
}

})